var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 13.5L15.914 10.414C15.5389 10.0391 15.0303 9.82843 14.5 9.82843C13.9697 9.82843 13.4611 10.0391 13.086 10.414L4 19.5M3 1.5H17C18.1046 1.5 19 2.39543 19 3.5V17.5C19 18.6046 18.1046 19.5 17 19.5H3C1.89543 19.5 1 18.6046 1 17.5V3.5C1 2.39543 1.89543 1.5 3 1.5ZM9 7.5C9 8.60457 8.10457 9.5 7 9.5C5.89543 9.5 5 8.60457 5 7.5C5 6.39543 5.89543 5.5 7 5.5C8.10457 5.5 9 6.39543 9 7.5Z",
    stroke: "#0071E7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectorIcon);
export default __webpack_public_path__ + "static/media/SelectorIcon.308bb05b315ee70924bf076cfbe8438a.svg";
export { ForwardRef as ReactComponent };